import API from "../../Api";
import {
  CNPDataOrder,
  FirstDataOrder,
  offlineOrderData,
  RazorPayTransferOrder,
  StripeInitiatePaymentPayload,
} from "./PaymentModels";
import { encryptJson } from "../../utils/react-ec-utils";
import axios from "axios";
import { CARD_TOKENIZATION_URL, USER_DETAILS, USER_ID } from "../../constants";
import { getCookie } from "../../../helper/cookieHelper";
import { createRequest } from "../../utils/hmac-utils";

const getUserDetailsFromCookie = () => getCookie(USER_DETAILS) || {};

const buildPaymentContactPayload = (details: any, userID: string) => {
  const userDetails = getUserDetailsFromCookie();

  return {
    customerId: userID,
    email: details?.email || details?.emailId || userDetails?.email || "",
    mobileNumber: details?.mobileNumber || details?.mobileNo || userDetails?.mobilePhone || "",
  };
};

export async function razorPayTransferOrderAPI(details: RazorPayTransferOrder) {
  const userID = getCookie(USER_ID)
  const payload = buildPaymentContactPayload(details, userID);
  // const data = encryptJson(payload);
   const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: "/api/customers/payment/authorize",
    data: hmacRequest ,
    //params:{data}
  });
}
export async function firstDataTransferOrderAPI(details: FirstDataOrder) {
  const userID = getCookie(USER_ID)
  const payload = buildPaymentContactPayload(details, userID);
  // const data = encryptJson(payload);
    const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: "/api/customers/payment/authorize-payment",
    data:hmacRequest ,
  });
}

export async function catpurePaymentAPI(details: any) {
  const userID = getCookie(USER_ID)
  const payload = buildPaymentContactPayload(details, userID);
  // const data = encryptJson(payload);
      const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: "/api/customers/payment/collect-payment",
    data: hmacRequest ,
  });
}

export function stripeInitatePaymentAPI(details: StripeInitiatePaymentPayload) {
  return API({
    method: "post",
    url: "/payment/initiatePayment",
    data: details,
  });
}

export async  function offlinePaymentAPI(details: offlineOrderData) {
  const userID = getCookie(USER_ID)
  const userDetails = getUserDetailsFromCookie();
  const paymentDetails = details as any;
  const { tableId, forceV2TransactionApi, ...restDetails } = paymentDetails;
  const useV2TransactionApi = Boolean(tableId || forceV2TransactionApi);
  const payload = {
    ...restDetails,
    ...(tableId ? { tableId } : {}),
    customerId: userID || paymentDetails?.customerId || "",
    emailId: paymentDetails?.emailId || userDetails?.email || "",
    mobileNo: paymentDetails?.mobileNo || userDetails?.mobilePhone || "",
    channel: "online",
  };
  const hmacRequest = useV2TransactionApi ? null : await createRequest(payload);
  return API({
    method: "post",
    url: useV2TransactionApi
      ? "/api/customers/payment/initiate-offline-payment/v2"
      : "/api/customers/payment/initiate-offline-payment",
    data: useV2TransactionApi ? payload : hmacRequest,
  });
}

export async function initiatetCNPPayemnetAPI(details: CNPDataOrder) {
  const userID = getCookie(USER_ID)
  const userDetails = getUserDetailsFromCookie();
  const cdUserDetails = JSON.parse(localStorage.getItem("CDUSER") || "{}");
  const paymentDetails = details as any;
  const { tableId, forceV2TransactionApi, ...restDetails } = paymentDetails;
  const useV2TransactionApi = Boolean(tableId || forceV2TransactionApi);

  const payload = {
    ...restDetails,
    ...(tableId ? { tableId } : {}),
    customerId: userID || paymentDetails?.customerId || "",
    email: paymentDetails?.email || paymentDetails?.emailId || userDetails?.email || "",
    mobileNumber:
      paymentDetails?.mobileNumber ||
      paymentDetails?.mobileNo ||
      userDetails?.mobilePhone ||
      cdUserDetails?.mobileNumber ||
      "",
  };
  const encryptedPayload = encryptJson(payload);
  const hmacRequest = useV2TransactionApi ? null : await createRequest(payload);
  return API({
    method: "post",
    url: useV2TransactionApi
      ? "/api/customers/payment/start-transaction/v2"
      : "/api/customers/payment/start-transaction",
    data: useV2TransactionApi ? { data: encryptedPayload } : hmacRequest,
  });
}

export function tokenizeCardDetail(cardData: any) {
  const { tokenAuthKey, ...cardPayload } = cardData ?? {};
  return axios.post(CARD_TOKENIZATION_URL, cardPayload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: tokenAuthKey || "68bef434f32547a5840ad7048b477a67",
    },
  });
}

export async function saveCardDetail(cardData: any) {
  const userID = getCookie(USER_ID)
  const payload = {...cardData, customerId:userID};
    const hmacRequest = await createRequest(payload);
  // const data = encryptJson(cardData);
  return API({
    method: "post",
    url: "/api/customers/payment/add-cards",
    data: hmacRequest,
  });
}

export async function getCardDetails(customerId: string) {
  const userID = getCookie(USER_ID)
  const payload = { customerId: userID || customerId };
  const userDetails = getUserDetailsFromCookie();
  // const data = encryptJson(cardData);
    // const hmacRequest = await createRequest(payload);
  return API({
    method: "get",
    url: `/api/customers/payment/fetch-cards?emailId=${userDetails?.email || ""}&mobileNo=${userDetails?.mobilePhone || ""}`,
    params: payload,
  });
}

export function deleteCardDetails(payload: any) {
  const userDetails = getUserDetailsFromCookie();
  const cardId = payload?.cardId ?? payload;
  const emailId = payload?.emailId || payload?.email || userDetails?.email || "";
  const mobileNo = payload?.mobileNo || payload?.mobilePhone || userDetails?.mobilePhone || "";
  // const data = encryptJson(cardData);
  return API({
    method: "delete",
    url: `/api/customers/payment/remove-cards?emailId=${encodeURIComponent(emailId)}&mobileNo=${encodeURIComponent(mobileNo)}`,
    params: { cardId },
  });
}

